// extracted by mini-css-extract-plugin
export default {"marqueeWrapper":"pXQmjc","marqueeWrapperCurrentFormat":"IV0PaF"};